import React from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTwitter,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

const Contact = () => {

    const data = useStaticQuery(graphql`
              query {
                allContentfulContact{
                    edges{
                    node{
                        title
                        nameTitle
                        nameDesc
                        organisationName
                        organisationDesc
                        email
                        emailDesc
                        message
                        messageDesc
                        sharingMessage
                        gdprMessage
                        submitButtonText
                    }
                    }
                }
                
                allContentfulMission {
                    edges {
                        node {
                            twitterLink
                            link1Description
                            linkedinLink
                            link2Description
                        }
                    }
                }
            }
        `)    

                const { title,
                        nameTitle,
                        nameDesc,
                        organisationName,
                        organisationDesc,
                        email,
                        emailDesc,
                        message,
                        messageDesc,
                        sharingMessage,
                        gdprMessage,
                        submitButtonText } = data.allContentfulContact.edges[0].node


                const { twitterLink,
                        link1Description,
                        linkedinLink,
                        link2Description } = data.allContentfulMission.edges[0].node
    
                        return (
    
    <section id="contact" className="py-5 second-bg-color">
      <Container className="pt-5">
        <h1
        className="d-none d-md-block display-4 font-weight-bolder text-center text-success text-uppercase py-5"
      >
        {title}
      </h1>
      <h2
        className="d-sm-block d-md-none d-lg-none d-xl-none font-weight-bolder text-center text-success text-uppercase py-5"
      >
        {title}
      </h2>
        <Row className="align-items-center">
          <Col sm="12" md="10" lg="9">
            <Container id="contact-form" className="rounded p-5 bg-transparent">
              <Form as='form' netlify>
                <div className="form-group row">
                  <label
                    htmlFor="inputName"
                    className="col-md-12 col-lg-3 col-form-label text-uppercase"
                    ><strong>{nameTitle}</strong></label>
                  <div className="col-md-12 col-lg-9">
                    <input
                      type="name"
                      className="form-control"
                      id="inputName"
                      name='form-name'
                      placeholder={nameDesc}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label
                    htmlFor="inputBusiness"
                    className="col-md-12 col-lg-3 col-form-label text-uppercase"
                    ><strong>{organisationName}</strong>
                    </label>
                  <div className="col-md-12 col-lg-9">
                    <input
                      type="name"
                      className="form-control"
                      name='form-organisation'
                      id="inputBusiness"
                      placeholder={organisationDesc}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label
                    htmlFor="inputEmail"
                    className="col-md-12 col-lg-3 col-form-label text-uppercase"
                    ><strong>{email}</strong>
                    </label>
                  <div className="col-md-12 col-lg-9">
                    <input
                      type="email"
                      className="form-control"
                      name='form-email'
                      id="inputEmail"
                      placeholder={emailDesc}
                    />
                  </div>
                </div>

                <small id="emailHelp" className="mb-2 form-text text-muted"
                  >{sharingMessage}
                  </small>

                <div className="form-group row">
                  <label
                    htmlFor="inputMessage"
                    className="col-md-12 col-lg-3 col-form-label text-uppercase"
                    ><strong>{message}</strong>
                    </label>
                  <div className="col-md-12 col-lg-9">
                    <textarea
                      className="form-control"
                      id="inputMessage"
                      name='form-message'
                      rows="5"
                      placeholder={messageDesc}
                    ></textarea>
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-md-12 col-lg-3"></div>
                  <div className="col-md-12 col-lg-9">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        name="form-checkbox"
                        type="checkbox"
                        id="gridCheck1"
                      />
                      <label className="form-check-label" htmlFor="gridCheck1">
                        {gdprMessage}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-sm-10">
                    <Button type="submit" className="btn btn-success text-uppercase">{submitButtonText}</Button>
                  </div>
                </div>
                <div data-netlify-recaptcha="true"></div>
              </Form>
            </Container>
          </Col>
          <Col sm="12" md="2" lg="3" className="align-content-center">
            
            <div className="row m-5">
              <Col className="col d-flex justify-content-center">
                <a className="text-success" href={twitterLink} target="_blank" rel="noopenner noreferrer">
                  <FontAwesomeIcon icon={faTwitter} size="3x" data-toggle="tooltip"
                  data-placement="left"
                  title={link1Description}></FontAwesomeIcon>
                </a>
              </Col>
            </div>
            <div className="row m-5">
              <Col className="col d-flex justify-content-center">
                <a className="text-success" href={linkedinLink} target="_blank" rel="noopenner noreferrer">
                  <FontAwesomeIcon icon={faLinkedin} size="3x" data-toggle="tooltip"
                  data-placement="left"
                  title={link2Description}></FontAwesomeIcon>
                </a>
              </Col>
            </div>
            

          </Col>
        </Row>

      </Container>
    </section>

    )
}

export default Contact
